import { Draft, PayloadAction }      from '@reduxjs/toolkit';
import { IEventParentCategoryState } from 'Redux/Slices/EventParentCategory/EventParentCategorySlice';
import { EventParentCategory }       from 'Domain/Models';
import { PayloadActionList }         from 'Utils';
import { removeActionTypes }         from 'Utils/ReducerUtility';


export const findEventParentCategoriesRequest = (state: Draft<IEventParentCategoryState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEventParentCategoriesSuccess = (state: Draft<IEventParentCategoryState>, { type, payload }: PayloadAction<{
  eventParentCategories: Record<string, EventParentCategory>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.eventParentCategories;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findEventParentCategoriesFailure = (state: Draft<IEventParentCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
